export default __webpack_public_path__ + "static/media/H91A2145.e06cb4d0.jpg";